import React, {
  type ReactElement,
  type ReactNode,
  cloneElement,
  isValidElement,
} from "react";
import { FormattedMessage } from "react-intl";

export type FormLabelType = ReactNode;

export interface IFormLabelRendererProps {
  label: FormLabelType;
  children: (translatedString?: string) => ReactNode;
}

export const FormLabelRenderer = ({
  label,
  children,
}: IFormLabelRendererProps) => {
  if (label === null) {
    return <>{children()}</>;
  } else if (typeof label === "string") {
    return <>{children(label)}</>;
  } else if (isValidElement(label) && label.type === FormattedMessage) {
    return (
      <>
        {cloneElement(label as ReactElement<any>, {
          children,
        })}
      </>
    );
  } else {
    return <>{children}</>;
  }
};
